module.exports = __webpack_public_path__ + "static/media/replace-roof-graphic.8353fb63.png";